<template>
  <div class="summary">
    <div
      class="summary-overlay"
      :class="{
        'summary-overlay-active': statuses.changeStatusForm.length > 0,
      }"
      @click="statuses.changeStatusForm = ''"
    ></div>
    <new-transaction-modal ref="typeModal" @submitted="modalIsSubmitted" />

    <m-finance-transaction
      ref="depositModal"
      :active="isShowDepositTransactionModal"
      type="deposit"
      :current-user-personal-amount="money.depositLocalValue"
      @close="isShowDepositTransactionModal = false"
      @submitDeposit="addDataToDeposit"
    />
    <m-finance-transaction
      :active="isShowPersonalAccountTransactionModal"
      type="personal_account"
      @close="isShowPersonalAccountTransactionModal = false"
      @submitPersonalAccount="addDataToPersonalAccount"
    />
    <div class="summary-container-desktop">
      <div
        v-if="userHavePermissionMainFactors() || userHavePermissionFinesAndEncourage()"
        class="d-flex flex-column w-100"
      >
        <div v-if="userHavePermissionMainFactors()" class="summary-general">
          <div v-if="general.isLoaded" class="summary-general-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div v-if="!general.isLoaded" class="summary-general-title">Основные показатели</div>
          <c-switcher
            v-if="!general.isLoaded"
            v-model="general.tabsLocal"
            class="summary-general-tabs"
            type="group"
            :items="[
              { label: 'Сегодня', value: 'today' },
              { label: 'Неделя', value: 'sunday' },
              { label: 'Текущий месяц', value: 'currentMonth' },
              { label: 'Прошлый месяц', value: 'previousMonth' },
            ]"
          />
          <div v-if="!general.isLoaded" class="summary-general-main">
            <div class="summary-general-main-salary">
              <div class="summary-general-main-salary-amount">
                {{ formatAmount(general[general.tabsLocal].salary) }}
                {{ currencyLabel }}
              </div>
              <div class="summary-general-main-salary-month">{{ general[general.tabsLocal].interval }}</div>
            </div>
            <div class="summary-general-main-additionally">
              <div class="summary-general-main-additionally-item">
                <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="time" />
                <div class="summary-general-main-additionally-item-text">
                  {{ general[general.tabsLocal].hoursWorked }} / {{ general[general.tabsLocal].daysWorked }}
                </div>
              </div>
              <div class="summary-general-main-additionally-item">
                <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="point" />
                <div class="summary-general-main-additionally-item-text">{{ general[general.tabsLocal].point }}</div>
              </div>
            </div>
          </div>
          <div v-if="!general.isLoaded" class="summary-general-money">
            <div class="summary-general-money-item">
              <div class="summary-general-money-item-amount">
                {{ formatAmount(general[general.tabsLocal].money.main.amount) }}
                {{currencyLabel}}
              </div>
              <div class="summary-general-money-item-title">Основная часть</div>
            </div>
            <div
              class="summary-general-money-item"
              :class="{
                'summary-general-money-item-green': general[general.tabsLocal].money.variable.amount > 0,
                'summary-general-money-item-gray': general[general.tabsLocal].money.variable.amount === 0,
              }"
            >
              <div class="summary-general-money-item-amount">
                {{ formatAmount(general[general.tabsLocal].money.variable.amount) }}
                {{currencyLabel}}
              </div>
              <div class="summary-general-money-item-title">Переменная часть</div>
            </div>
            <div
              class="summary-general-money-item"
              :class="{
                'summary-general-money-item-red': general[general.tabsLocal].money.depremal.amount > 0,
                'summary-general-money-item-gray': general[general.tabsLocal].money.depremal.amount === 0,
              }"
            >
              <div class="summary-general-money-item-amount">
                {{ formatAmount(general[general.tabsLocal].money.depremal.amount) }}
                {{currencyLabel}}
              </div>
              <div class="summary-general-money-item-title">Депрем-е</div>
            </div>
            <div
              class="summary-general-money-item"
              :class="{
                'summary-general-money-item-green': general[general.tabsLocal].money.encouragement.amount > 0,
                'summary-general-money-item-gray': general[general.tabsLocal].money.encouragement.amount === 0,
              }"
            >
              <div
                v-if="general[general.tabsLocal].money.encouragement.count > 0"
                class="summary-general-money-item-count"
              >
                {{ general[general.tabsLocal].money.encouragement.count }}
              </div>
              <div class="summary-general-money-item-amount">
                {{ formatAmount(general[general.tabsLocal].money.encouragement.amount) }}
                {{currencyLabel}}
              </div>
              <div class="summary-general-money-item-title">Поощрения</div>
            </div>
            <div
              class="summary-general-money-item"
              :class="{
                'summary-general-money-item-red': general[general.tabsLocal].money.fines.amount > 0,
                'summary-general-money-item-gray': general[general.tabsLocal].money.fines.amount === 0,
              }"
            >
              <div v-if="general[general.tabsLocal].money.fines.count > 0" class="summary-general-money-item-count">
                {{ general[general.tabsLocal].money.fines.count }}
              </div>
              <div class="summary-general-money-item-amount">
                {{ formatAmount(general[general.tabsLocal].money.fines.amount) }}
                {{currencyLabel}}
              </div>
              <div class="summary-general-money-item-title">Штрафы</div>
            </div>
          </div>
        </div>
        <div v-if="userHavePermissionFinesAndEncourage()" class="d-flex">
          <div class="summary-encourage" @click="$router.push({ name: 'personal-employee-discipline' })">
            <div v-if="encourageIsLoaded" class="summary-encourage-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!encourageIsLoaded" class="summary-encourage-title">
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z"
                  stroke="#12C971"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="summary-encourage-title-text">Поощрения</div>
            </div>
            <div v-for="(item, i) in encourageLocalItems" :key="`encourage-s-${i}-${item.name}`" class="summary-encourage-item">
              <template v-if="!encourageIsLoaded">
                <div class="summary-encourage-item-text">{{ item.name }}</div>
                <div class="summary-encourage-item-date">{{ item.date }}</div>
              </template>
            </div>
            <div v-if="!encourageIsLoaded && encourageLocalItems.length === 0" class="summary-encourage-empty">
              Поощрений пока нет
            </div>
          </div>
          <div class="summary-fines" @click="$router.push({ name: 'personal-employee-discipline' })">
            <div v-if="finesIsLoaded" class="summary-fines-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!finesIsLoaded" class="summary-fines-title">
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z"
                  stroke="#FF238D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="summary-fines-title-text">Частые нарушения</div>
            </div>
            <div v-for="fine in finesLocalItems" :key="`fine-${fine.name}`" class="summary-fines-item">
              <template v-if="!finesIsLoaded">
                <div class="summary-fines-item-text">{{ fine.name }}</div>
                <div class="summary-fines-item-count">
                  <div class="summary-fines-item-count-text">{{ fine.count }}</div>
                </div>
              </template>
            </div>
            <div v-if="!finesIsLoaded && finesLocalItems.length === 0" class="summary-fines-empty">
              Нарушений пока нет
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column w-100 summary-ml">
        <div class="summary-money">
          <div v-if="money.isLoaded" class="summary-money-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div
            v-if="!money.isLoaded"
            class="summary-money-item summary-money-item-yellow"
            :class="{
              'summary-money-item-yellow': money.depositLocalValue > 0 && money.depositLocalValue <= 1000,
              'summary-money-item-green': money.depositLocalValue === 3000,
              'summary-money-item-red': money.depositLocalValue <= 0 || money.depositLocalValue > 3000,
              'summary-money-item-clickable': userHavePermissionUpdateWorkerDeposit(),
            }"
            @click="showDepositModal"
          >
            <div class="summary-money-item-title">Депозит</div>
            <div class="summary-money-item-amount">
              <div class="summary-money-item-amount-text">
                {{ formatAmountWithNegative(money.depositLocalValue) }}
                {{currencyLabel}}
              </div>
              <c-button
                v-if="userHavePermissionUpdateWorkerDeposit()"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Редактировать',
                  placement: 'top',
                }"
                class="summary-money-item-amount-edit"
                icon="edit"
                size="iconic"
              />
            </div>
          </div>
          <div
            v-if="!money.isLoaded"
            class="summary-money-item"
            :class="{
              'summary-money-item-green': money.personalAccountValue > 0,
              'summary-money-item-red': money.personalAccountValue < 0,
              'summary-money-item-clickable': userHavePermissionUpdatePersonalAmount(),
            }"
            @click="userHavePermissionUpdatePersonalAmount() ? ($refs.typeModal.open()) : ''"
          >
            <div class="summary-money-item-title">Личный счёт</div>
            <div class="summary-money-item-amount">
              <div class="summary-money-item-amount-text">
                {{ formatAmountWithNegative(money.personalAccountValue) }}
                {{currencyLabel}}
              </div>
              <c-button
                v-if="userHavePermissionUpdatePersonalAmount()"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Редактировать',
                  placement: 'top',
                }"
                class="summary-money-item-amount-edit"
                icon="edit"
                size="iconic"
              />
            </div>
          </div>
          <div v-if="!money.isLoaded" class="summary-money-item">
            <div class="summary-money-item-title">Прем. счет</div>
            <div class="summary-money-item-amount">
              <div class="summary-money-item-amount-text">
                {{ formatAmountWithNegative(money.premiumAccountValue) }}
                {{currencyLabel}}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div
            v-if="userHavePermissionExpiredAndNeedAddDocuments()"
            class="summary-documents"
            @click="$router.push({ name: 'personal-employee-documents' })"
          >
            <div v-if="documents.isLoaded" class="summary-documents-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,
                  placement: 'top',
                }"
                class="summary-documents-item-icon summary-documents-item-icon-yellow"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15"
                    stroke="#9FA400"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ documents.needToAdd }}</div>
            </div>
            <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-hr"></div>
            <div v-if="!documents.isLoaded && documents.expired.length > 0" class="summary-documents-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,
                  placement: 'top',
                }"
                class="summary-documents-item-icon summary-documents-item-icon-red"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z"
                    fill="#FF238D"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ documents.expired }}</div>
            </div>
            <div
              v-if="!documents.isLoaded && documents.expired.length > 0 && documents.needToAdd.length === 0"
              class="summary-documents-hr"
            ></div>
            <div
              v-if="!documents.isLoaded && documents.expired.length === 0 && documents.needToAdd.length === 0"
              class="summary-documents-empty"
            >
              Нет проблем с документами
            </div>
          </div>
          <div
            v-if="userHavePermissionUniform()"
            :class="{
              'ml-0': !userHavePermissionExpiredAndNeedAddDocuments(),
            }"
            class="summary-uniform"
            @click="$router.push({ name: 'personal-employee-inventory-items' })"
          >
            <div v-if="inventory.isLoaded" class="summary-uniform-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,
                  placement: 'top',
                }"
                class="summary-uniform-item-icon summary-uniform-item-icon-yellow"
              >
                <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12"
                    stroke="#9FA400"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ inventory.notIssued }}</div>
            </div>
            <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-hr"></div>
            <div v-if="!inventory.isLoaded && inventory.expired.length > 0" class="summary-uniform-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Просроченные позиции: <b>${inventory.expired}</b>`,
                  placement: 'top',
                }"
                class="summary-uniform-item-icon summary-uniform-item-icon-red"
              >
                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z"
                    fill="#FF238D"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ inventory.expired }}</div>
            </div>
            <div
              v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length > 0"
              class="summary-uniform-hr"
            ></div>
            <div
              v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length === 0"
              class="summary-uniform-empty"
            >
              Нет проблем с инвентарем
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div v-if="notifications.userHasPermission" class="summary-notices">
            <div v-if="notifications.isLoaded" class="summary-notices-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!notifications.isLoaded" class="summary-notices-title">
              <div class="summary-notices-title-text">Уведомления</div>
              <div
                class="summary-notices-title-count"
                :class="{ 'summary-notices-title-count-grey': notifications.count === 0 }"
              >
                <div class="summary-notices-title-count-text">{{ notifications.count }}</div>
              </div>
            </div>
            <div
              v-for="(notification, desktopIndex) in notifications.items"
              :key="'notification' + desktopIndex + 'desktop'"
              class="summary-notices-item"
            >
              <template v-if="!notifications.isLoaded">
                <div class="summary-notices-item-text" v-html="notification.text">{{ notification.text }}</div>
                <div class="summary-notices-item-date">{{ notification.created }}</div>
              </template>
            </div>
            <div v-if="!notifications.isLoaded && notifications.items.length === 0" class="summary-notices-empty">
              Нет новых уведомлений
            </div>
          </div>
          <div
            :class="{
              'mt-0': !userHavePermissionUniform() && !userHavePermissionExpiredAndNeedAddDocuments(),
              'ml-0': !notifications.userHasPermission,
            }"
            class="summary-statuses"
          >
            <div v-if="statuses.isLoaded" class="summary-statuses-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div
              v-if="!statuses.isLoaded"
              class="summary-statuses-item"
              :class="{
                'summary-statuses-item-disabled':
                  statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'workerStatus',
              }"
            >
              <div class="summary-statuses-item-title">Статус сотрудника</div>
              <div v-if="statuses.changeStatusForm !== 'workerStatus'" class="summary-statuses-item-value">
                <div
                  :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
                  class="summary-statuses-item-text"
                >
                  {{ statuses.workerStatus }}
                </div>
                <c-button
                  v-if="userHavePermissionChangeWorkerStatuses"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Редактировать',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-icon"
                  size="iconic"
                  icon="edit"
                  @click="statuses.changeStatusForm = 'workerStatus'"
                />
              </div>
              <div v-else class="summary-statuses-item-value align-items-start w-100">
                <c-input
                  v-model="statuses.workerStatusLocal"
                  class="flex-grow-1 summary-statuses-item-value-input"
                  type="select"
                  :searchable="true"
                  :items="statuses.workerStatusLocalItem"
                />
                <c-button
                  key="workerStatus1"
                  v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                  class="summary-statuses-item-value-close-icon"
                  size="iconic"
                  :icon="{ icon: 'close', color: 'secondary' }"
                  @click="statuses.changeStatusForm = ''"
                />
                <c-button
                  key="workerStatus2"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Сохранить',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-apply-icon"
                  size="iconic"
                  :icon="{ icon: 'check', color: 'success' }"
                  @click="changeStatuses"
                />
              </div>
            </div>
            <div
              v-if="!statuses.isLoaded && userHavePermissionCharacteristic()"
              class="summary-statuses-item"
              :class="{
                'summary-statuses-item-disabled':
                  statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'characteristic',
              }"
            >
              <div class="summary-statuses-item-title">Характеристика</div>
              <div v-if="statuses.changeStatusForm !== 'characteristic'" class="summary-statuses-item-value">
                <div
                  :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
                  class="summary-statuses-item-text"
                >
                  {{ statuses.characteristic }}
                </div>
                <c-rank-info-icon
                  v-if="statuses.rankInfo !== null"
                  icon-key="rankinfo-summary-desktop"
                  class="summary-statuses-item-rankinfo-icon"
                  :data="{ action: statuses.rankInfo.action, value: statuses.rankInfo.value }"
                />
                <c-button
                  v-if="userHavePermissionChangeWorkerStatuses()"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Редактировать',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-icon"
                  size="iconic"
                  icon="edit"
                  @click="statuses.changeStatusForm = 'characteristic'"
                />
              </div>
              <div v-else class="summary-statuses-item-value align-items-start w-100">
                <c-input
                  v-model="statuses.characteristicLocalValue"
                  class="flex-grow-1 summary-statuses-item-value-input"
                  type="select"
                  :searchable="true"
                  :items="statuses.characteristicLocalItems"
                />
                <c-button
                  key="workerStatus1"
                  v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                  class="summary-statuses-item-value-close-icon"
                  size="iconic"
                  :icon="{ icon: 'close', color: 'secondary' }"
                  @click="statuses.changeStatusForm = ''"
                />
                <c-button
                  key="workerStatus2"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Сохранить',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-apply-icon"
                  size="iconic"
                  :icon="{ icon: 'check', color: 'success' }"
                  @click="changeStatuses"
                />
              </div>
            </div>
            <div
              v-if="!statuses.isLoaded"
              class="summary-statuses-item"
              :class="{
                'summary-statuses-item-disabled':
                  statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'employmentStatus',
              }"
            >
              <div class="summary-statuses-item-title">Статус трудоустройства</div>
              <div v-if="statuses.changeStatusForm !== 'employmentStatus'" class="summary-statuses-item-value">
                <div
                  :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.employmentStatus === 'Не выбрано' }"
                  class="summary-statuses-item-text"
                >
                  {{ statuses.employmentStatus }}
                </div>
                <c-button
                  v-if="userHavePermissionChangeWorkerStatuses()"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Редактировать',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-icon"
                  size="iconic"
                  icon="edit"
                  @click="statuses.changeStatusForm = 'employmentStatus'"
                />
              </div>
              <div v-else class="summary-statuses-item-value align-items-start w-100">
                <c-input
                  v-model="statuses.employmentStatusLocalValue"
                  class="flex-grow-1 summary-statuses-item-value-input"
                  type="select"
                  :searchable="true"
                  :items="statuses.employmentStatusLocalItems"
                />
                <c-button
                  key="workerStatus1"
                  v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                  class="summary-statuses-item-value-close-icon"
                  size="iconic"
                  :icon="{ icon: 'close', color: 'secondary' }"
                  @click="statuses.changeStatusForm = ''"
                />
                <c-button
                  key="workerStatus2"
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Сохранить',
                    placement: 'top',
                  }"
                  class="summary-statuses-item-value-apply-icon"
                  size="iconic"
                  :icon="{ icon: 'check', color: 'success' }"
                  @click="changeStatuses"
                />
              </div>
            </div>
            <div
              v-if="!statuses.isLoaded"
              class="summary-statuses-additions"
              :class="{
                'summary-statuses-additions-disabled':
                  statuses.changeStatusForm === 'characteristic' ||
                  statuses.changeStatusForm === 'employmentStatus' ||
                  statuses.changeStatusForm === 'workerStatus',
              }"
            >
              <div v-if="statuses.combinationFilials" class="summary-statuses-additions-item">
                <c-button icon="point" size="iconic" />
                <div class="summary-statuses-additions-item-text">Может работать в нескольких филиалах</div>
              </div>
              <div v-if="statuses.remoteJob" class="summary-statuses-additions-item">
                <c-button icon="home" size="iconic" />
                <div class="summary-statuses-additions-item-text">Может работать удалённо</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="summary-container-tablet">
      <div v-if="userHavePermissionMainFactors()" class="summary-general">
        <div v-if="general.isLoaded" class="summary-general-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!general.isLoaded" class="summary-general-title">Основные показатели</div>
        <c-switcher
          v-if="!general.isLoaded"
          v-model="general.tabsLocal"
          class="summary-general-tabs"
          type="group"
          :items="[
            { label: 'Сегодня', value: 'today' },
            { label: 'Неделя', value: 'sunday' },
            { label: 'Текущий месяц', value: 'currentMonth' },
            { label: 'Прошлый месяц', value: 'previousMonth' },
          ]"
        />
        <div v-if="!general.isLoaded" class="summary-general-main">
          <div class="summary-general-main-salary">
            <div class="summary-general-main-salary-amount">
              {{ formatAmount(general[general.tabsLocal].salary) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-main-salary-month">{{ general[general.tabsLocal].interval }}</div>
          </div>
          <div class="summary-general-main-additionally">
            <div class="summary-general-main-additionally-item">
              <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="time" />
              <div class="summary-general-main-additionally-item-text">
                {{ general[general.tabsLocal].hoursWorked }} / {{ general[general.tabsLocal].daysWorked }}
              </div>
            </div>
            <div class="summary-general-main-additionally-item">
              <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="point" />
              <div class="summary-general-main-additionally-item-text">{{ general[general.tabsLocal].point }}</div>
            </div>
          </div>
        </div>
        <div v-if="!general.isLoaded" class="summary-general-money">
          <div class="summary-general-money-item">
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.main.amount) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-money-item-title">Основная часть</div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-green': general[general.tabsLocal].money.variable.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.variable.amount === 0,
            }"
          >
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.variable.amount) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-money-item-title">Переменная часть</div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-red': general[general.tabsLocal].money.depremal.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.depremal.amount === 0,
            }"
          >
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.depremal.amount) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-money-item-title">Депрем-е</div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-green': general[general.tabsLocal].money.encouragement.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.encouragement.amount === 0,
            }"
          >
            <div
              v-if="general[general.tabsLocal].money.encouragement.count > 0"
              class="summary-general-money-item-count"
            >
              {{ general[general.tabsLocal].money.encouragement.count }}
            </div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.encouragement.amount) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-money-item-title">Поощрения</div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-red': general[general.tabsLocal].money.fines.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.fines.amount === 0,
            }"
          >
            <div v-if="general[general.tabsLocal].money.fines.count > 0" class="summary-general-money-item-count">
              {{ general[general.tabsLocal].money.fines.count }}
            </div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.fines.amount) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-money-item-title">Штрафы</div>
          </div>
        </div>
      </div>
      <div class="summary-money">
        <div v-if="money.isLoaded" class="summary-money-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div
          v-if="!money.isLoaded"
          class="summary-money-item summary-money-item-yellow"
          :class="{
            'summary-money-item-yellow': money.depositLocalValue > 0 && money.depositLocalValue <= 1000,
            'summary-money-item-green': money.depositLocalValue === 3000,
            'summary-money-item-red': money.depositLocalValue <= 0 || money.depositLocalValue > 3000,
            'summary-money-item-clickable': userHavePermissionUpdateWorkerDeposit(),
          }"
          @click="showDepositModal"
        >
          <div class="summary-money-item-title">Депозит</div>
          <div class="summary-money-item-amount">
            <div class="summary-money-item-amount-text">
              {{ formatAmount(money.depositLocalValue) }}
              {{currencyLabel}}
            </div>
            <c-button
              v-if="userHavePermissionUpdateWorkerDeposit()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-money-item-amount-edit"
              icon="edit"
              size="iconic"
            />
          </div>
        </div>
        <div
          v-if="!money.isLoaded"
          class="summary-money-item"
          :class="{
            'summary-money-item-green': money.personalAccountValue > 0,
            'summary-money-item-red': money.personalAccountValue < 0,
            'summary-money-item-clickable': userHavePermissionUpdatePersonalAmount(),
          }"
          @click="userHavePermissionUpdatePersonalAmount() ? ($refs.typeModal.open()) : ''"
        >
          <div class="summary-money-item-title">Личный счёт</div>
          <div class="summary-money-item-amount">
            <div class="summary-money-item-amount-text">
              {{ formatAmountWithNegative(money.personalAccountValue) }}
              {{currencyLabel}}
            </div>
            <c-button
              v-if="userHavePermissionUpdatePersonalAmount()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-money-item-amount-edit"
              icon="edit"
              size="iconic"
            />
          </div>
        </div>
        <div v-if="!money.isLoaded" class="summary-money-item">
          <div class="summary-money-item-title">Прем. счет</div>
          <div class="summary-money-item-amount">
            <div class="summary-money-item-amount-text">
              {{ formatAmountWithNegative(money.premiumAccountValue) }}
              {{currencyLabel}}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex w-100">
        <div
          v-if="userHavePermissionFinesAndEncourage()"
          class="summary-encourage"
          @click="$router.push({ name: 'personal-employee-discipline' })"
        >
          <div v-if="encourageIsLoaded" class="summary-encourage-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div v-if="!encourageIsLoaded" class="summary-encourage-title">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z"
                stroke="#12C971"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="summary-encourage-title-text">Поощрения</div>
          </div>
          <div v-for="(item, i) in encourageLocalItems" :key="`encourage-i-${i}-${item.name}`" class="summary-encourage-item">
            <template v-if="!encourageIsLoaded">
              <div class="summary-encourage-item-text">{{ item.name }}</div>
              <div class="summary-encourage-item-date">{{ item.date }}</div>
            </template>
          </div>
          <div v-if="!encourageIsLoaded && encourageLocalItems.length === 0" class="summary-encourage-empty">
            Поощрений пока нет
          </div>
        </div>
        <div
          v-if="userHavePermissionFinesAndEncourage()"
          class="summary-fines"
          @click="$router.push({ name: 'personal-employee-discipline' })"
        >
          <div v-if="finesIsLoaded" class="summary-fines-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div v-if="!finesIsLoaded" class="summary-fines-title">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z"
                stroke="#FF238D"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="summary-fines-title-text">Частые нарушения</div>
          </div>
          <div v-for="fine in finesLocalItems" :key="`fine-i-${fine.name}`" class="summary-fines-item">
            <template v-if="!finesIsLoaded">
              <div class="summary-fines-item-text">{{ fine.name }}</div>
              <div class="summary-fines-item-count">
                <div class="summary-fines-item-count-text">{{ fine.count }}</div>
              </div>
            </template>
          </div>
          <div v-if="!finesIsLoaded && finesLocalItems.length === 0" class="summary-fines-empty">
            Нарушений пока нет
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div
            v-if="userHavePermissionExpiredAndNeedAddDocuments()"
            :class="{ 'ml-0': !userHavePermissionFinesAndEncourage() }"
            class="summary-documents"
            @click="$router.push({ name: 'personal-employee-documents' })"
          >
            <div v-if="documents.isLoaded" class="summary-documents-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,
                  placement: 'top',
                }"
                class="summary-documents-item-icon summary-documents-item-icon-yellow"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15"
                    stroke="#9FA400"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ documents.needToAdd }}</div>
            </div>
            <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-hr"></div>
            <div v-if="!documents.isLoaded && documents.expired.length > 0" class="summary-documents-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,
                  placement: 'top',
                }"
                class="summary-documents-item-icon summary-documents-item-icon-red"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z"
                    fill="#FF238D"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ documents.expired }}</div>
            </div>
            <div
              v-if="!documents.isLoaded && documents.expired.length > 0 && documents.needToAdd.length === 0"
              class="summary-documents-hr"
            ></div>
            <div
              v-if="!documents.isLoaded && documents.expired.length === 0 && documents.needToAdd.length === 0"
              class="summary-documents-empty"
            >
              Нет проблем с документами
            </div>
          </div>
          <div
            v-if="userHavePermissionUniform()"
            :class="{
              'ml-0': !userHavePermissionFinesAndEncourage(),
              'mt-0': !userHavePermissionExpiredAndNeedAddDocuments(),
            }"
            class="summary-uniform"
            @click="$router.push({ name: 'personal-employee-inventory-items' })"
          >
            <div v-if="inventory.isLoaded" class="summary-uniform-loader">
              <font-awesome-icon :icon="icon" spin />
            </div>
            <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,
                  placement: 'top',
                }"
                class="summary-uniform-item-icon summary-uniform-item-icon-yellow"
              >
                <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12"
                    stroke="#9FA400"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ inventory.notIssued }}</div>
            </div>
            <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-hr"></div>
            <div v-if="!inventory.isLoaded && inventory.expired.length > 0" class="summary-uniform-item">
              <div
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: `Просроченные позиции: <b>${inventory.expired}</b>`,
                  placement: 'top',
                }"
                class="summary-uniform-item-icon summary-uniform-item-icon-red"
              >
                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z"
                    fill="#FF238D"
                  />
                </svg>
              </div>
              <div class="summary-documents-item-text">{{ inventory.expired }}</div>
            </div>
            <div
              v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length > 0"
              class="summary-uniform-hr"
            ></div>
            <div
              v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length === 0"
              class="summary-uniform-empty"
            >
              Нет проблем с инвентарем
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex w-100">
        <div v-if="notifications.userHasPermission" class="summary-notices">
          <div v-if="notifications.isLoaded" class="summary-notices-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div v-if="!notifications.isLoaded" class="summary-notices-title">
            <div class="summary-notices-title-text">Уведомления</div>
            <div
              class="summary-notices-title-count"
              :class="{ 'summary-notices-title-count-grey': notifications.count === 0 }"
            >
              <div class="summary-notices-title-count-text">{{ notifications.count }}</div>
            </div>
          </div>
          <div
            v-for="(notification, tabletIndex) in notifications.items"
            :key="'notification' + tabletIndex + 'tablet'"
            class="summary-notices-item"
          >
            <template v-if="!notifications.isLoaded">
              <div class="summary-notices-item-text" v-html="notification.text">{{ notification.text }}</div>
              <div class="summary-notices-item-date">{{ notification.created }}</div>
            </template>
          </div>
          <div v-if="!notifications.isLoaded && notifications.items.length === 0" class="summary-notices-empty">
            Нет новых уведомлений
          </div>
        </div>
        <div :class="{ 'ml-0': !notifications.userHasPermission }" class="summary-statuses">
          <div v-if="statuses.isLoaded" class="summary-statuses-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <div
            v-if="!statuses.isLoaded"
            class="summary-statuses-item"
            :class="{
              'summary-statuses-item-disabled':
                statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'workerStatus',
            }"
          >
            <div class="summary-statuses-item-title">Статус сотрудника</div>
            <div v-if="statuses.changeStatusForm !== 'workerStatus'" class="summary-statuses-item-value">
              <div
                :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
                class="summary-statuses-item-text"
              >
                {{ statuses.workerStatus }}
              </div>
              <c-button
                v-if="userHavePermissionChangeWorkerStatuses"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Редактировать',
                  placement: 'top',
                }"
                class="summary-statuses-item-value-icon"
                size="iconic"
                icon="edit"
                @click="statuses.changeStatusForm = 'workerStatus'"
              />
            </div>
            <div v-else class="summary-statuses-item-value align-items-start w-100">
              <c-input
                v-model="statuses.workerStatusLocal"
                class="flex-grow-1 summary-statuses-item-value-input"
                type="select"
                :searchable="true"
                :items="statuses.workerStatusLocalItem"
              />
              <c-button
                key="workerStatus1"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                class="summary-statuses-item-value-close-icon"
                size="iconic"
                :icon="{ icon: 'close', color: 'secondary' }"
                @click="statuses.changeStatusForm = ''"
              />
              <c-button
                key="workerStatus2"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
                class="summary-statuses-item-value-apply-icon"
                size="iconic"
                :icon="{ icon: 'check', color: 'success' }"
                @click="changeStatuses"
              />
            </div>
          </div>
          <div
            v-if="!statuses.isLoaded && userHavePermissionCharacteristic()"
            class="summary-statuses-item"
            :class="{
              'summary-statuses-item-disabled':
                statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'characteristic',
            }"
          >
            <div class="summary-statuses-item-title">Характеристика</div>
            <div v-if="statuses.changeStatusForm !== 'characteristic'" class="summary-statuses-item-value">
              <div
                :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
                class="summary-statuses-item-text"
              >
                {{ statuses.characteristic }}
              </div>
              <c-rank-info-icon
                v-if="statuses.rankInfo !== null"
                icon-key="rankinfo-summary-tablet"
                class="summary-statuses-item-rankinfo-icon"
                :data="{ action: statuses.rankInfo.action, value: statuses.rankInfo.value }"
              />
              <c-button
                v-if="userHavePermissionChangeWorkerStatuses()"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Редактировать',
                  placement: 'top',
                }"
                class="summary-statuses-item-value-icon"
                size="iconic"
                icon="edit"
                @click="statuses.changeStatusForm = 'characteristic'"
              />
            </div>
            <div v-else class="summary-statuses-item-value align-items-start w-100">
              <c-input
                v-model="statuses.characteristicLocalValue"
                class="flex-grow-1 summary-statuses-item-value-input"
                type="select"
                :searchable="true"
                :items="statuses.characteristicLocalItems"
              />
              <c-button
                key="workerStatus1"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                class="summary-statuses-item-value-close-icon"
                size="iconic"
                :icon="{ icon: 'close', color: 'secondary' }"
                @click="statuses.changeStatusForm = ''"
              />
              <c-button
                key="workerStatus2"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
                class="summary-statuses-item-value-apply-icon"
                size="iconic"
                :icon="{ icon: 'check', color: 'success' }"
                @click="changeStatuses"
              />
            </div>
          </div>
          <div
            v-if="!statuses.isLoaded"
            class="summary-statuses-item"
            :class="{
              'summary-statuses-item-disabled':
                statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'employmentStatus',
            }"
          >
            <div class="summary-statuses-item-title">Статус трудоустройства</div>
            <div v-if="statuses.changeStatusForm !== 'employmentStatus'" class="summary-statuses-item-value">
              <div
                :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.employmentStatus === 'Не выбрано' }"
                class="summary-statuses-item-text"
              >
                {{ statuses.employmentStatus }}
              </div>
              <c-button
                v-if="userHavePermissionChangeWorkerStatuses()"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Редактировать',
                  placement: 'top',
                }"
                class="summary-statuses-item-value-icon"
                size="iconic"
                icon="edit"
                @click="statuses.changeStatusForm = 'employmentStatus'"
              />
            </div>
            <div v-else class="summary-statuses-item-value align-items-start w-100">
              <c-input
                v-model="statuses.employmentStatusLocalValue"
                class="flex-grow-1 summary-statuses-item-value-input"
                type="select"
                :searchable="true"
                :items="statuses.employmentStatusLocalItems"
              />
              <c-button
                key="workerStatus1"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
                class="summary-statuses-item-value-close-icon"
                size="iconic"
                :icon="{ icon: 'close', color: 'secondary' }"
                @click="statuses.changeStatusForm = ''"
              />
              <c-button
                key="workerStatus2"
                v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
                class="summary-statuses-item-value-apply-icon"
                size="iconic"
                :icon="{ icon: 'check', color: 'success' }"
                @click="changeStatuses"
              />
            </div>
          </div>
          <div
            v-if="!statuses.isLoaded"
            class="summary-statuses-additions"
            :class="{
              'summary-statuses-additions-disabled':
                statuses.changeStatusForm === 'characteristic' ||
                statuses.changeStatusForm === 'employmentStatus' ||
                statuses.changeStatusForm === 'workerStatus',
            }"
          >
            <div v-if="statuses.combinationFilials" class="summary-statuses-additions-item">
              <c-button icon="point" size="iconic" />
              <div class="summary-statuses-additions-item-text">Может работать в нескольких филиалах</div>
            </div>
            <div v-if="statuses.remoteJob" class="summary-statuses-additions-item">
              <c-button icon="home" size="iconic" />
              <div class="summary-statuses-additions-item-text">Может работать удалённо</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="summary-container-mobile">
      <div class="summary-money">
        <div v-if="money.isLoaded" class="summary-money-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div
          v-if="!money.isLoaded"
          class="summary-money-item summary-money-item-yellow"
          :class="{
            'summary-money-item-yellow': money.depositLocalValue > 0 && money.depositLocalValue <= 1000,
            'summary-money-item-green': money.depositLocalValue === 3000,
            'summary-money-item-red': money.depositLocalValue <= 0 || money.depositLocalValue > 3000,
            'summary-money-item-clickable': userHavePermissionUpdateWorkerDeposit(),
          }"
          @click="userHavePermissionUpdateWorkerDeposit() ? (isShowDepositTransactionModal = true) : ''; this.$refs.depositModal.open(); console.log('hello;')"
        >
          <div class="summary-money-item-title">Депозит</div>
          <div class="summary-money-item-amount">
            <div
              class="summary-money-item-amount-text"
              :class="{ 'summary-money-item-amount-text-no-edit': !userHavePermissionUpdatePersonalAmount() }"
            >
              {{ formatAmountWithNegative(money.depositLocalValue) }}
              {{currencyLabel}}
            </div>
            <c-button
              v-if="userHavePermissionUpdateWorkerDeposit()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-money-item-amount-edit"
              icon="edit"
              size="iconic"
            />
          </div>
        </div>
        <div
          v-if="!money.isLoaded"
          class="summary-money-item summary-money-item-clickable"
          :class="{
            'summary-money-item-green': money.personalAccountValue > 0,
            'summary-money-item-red': money.personalAccountValue < 0,
            'summary-money-item-clickable': userHavePermissionUpdatePersonalAmount(),
          }"
          @click="userHavePermissionUpdatePersonalAmount() ? ($refs.typeModal.open()) : ''"
        >
          <div class="summary-money-item-title">Личный счёт</div>
          <div class="summary-money-item-amount">
            <div
              class="summary-money-item-amount-text"
              :class="{ 'summary-money-item-amount-text-no-edit': !userHavePermissionUpdatePersonalAmount() }"
            >
              {{ formatAmountWithNegative(money.personalAccountValue) }}
              {{currencyLabel}}
            </div>
            <c-button
              v-if="userHavePermissionUpdatePersonalAmount()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-money-item-amount-edit"
              icon="edit"
              size="iconic"
            />
          </div>
        </div>
        <div v-if="!money.isLoaded" class="summary-money-item">
          <div class="summary-money-item-title">Прем. счет</div>
          <div class="summary-money-item-amount">
            <div class="summary-money-item-amount-text summary-money-item-amount-text-no-edit">
              {{ formatAmountWithNegative(money.premiumAccountValue) }}
              {{currencyLabel}}
            </div>
          </div>
        </div>
      </div>
      <div v-if="userHavePermissionMainFactors()" class="summary-general">
        <div v-if="general.isLoaded" class="summary-general-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!general.isLoaded" class="summary-general-title">Основные показатели</div>
        <c-switcher
          v-if="!general.isLoaded"
          v-model="general.tabsLocal"
          class="summary-general-tabs"
          type="group"
          :items="[
            { label: 'Сегодня', value: 'today' },
            { label: 'Неделя', value: 'sunday' },
            { label: 'Текущий месяц', value: 'currentMonth' },
            { label: 'Прошлый месяц', value: 'previousMonth' },
          ]"
        />
        <div v-if="!general.isLoaded" class="summary-general-main">
          <div class="summary-general-main-salary">
            <div class="summary-general-main-salary-amount">
              {{ formatAmount(general[general.tabsLocal].salary) }}
              {{currencyLabel}}
            </div>
            <div class="summary-general-main-salary-month">{{ general[general.tabsLocal].interval }}</div>
          </div>
          <div class="summary-general-main-additionally">
            <div class="summary-general-main-additionally-item">
              <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="time" />
              <div class="summary-general-main-additionally-item-text">
                {{ general[general.tabsLocal].hoursWorked }} / {{ general[general.tabsLocal].daysWorked }}
              </div>
            </div>
            <div class="summary-general-main-additionally-item">
              <c-button class="summary-general-main-additionally-item-icon" size="iconic" icon="point" />
              <div class="summary-general-main-additionally-item-text">{{ general[general.tabsLocal].point }}</div>
            </div>
          </div>
        </div>
        <div v-if="!general.isLoaded" class="summary-general-money">
          <div class="summary-general-money-item">
            <div class="summary-general-money-item-title">Основная часть</div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.main.amount) }}
              {{currencyLabel}}
            </div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-green': general[general.tabsLocal].money.variable.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.variable.amount === 0,
            }"
          >
            <div class="summary-general-money-item-title">Переменная часть</div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.variable.amount) }}
              {{currencyLabel}}
            </div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-red': general[general.tabsLocal].money.depremal.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.depremal.amount === 0,
            }"
          >
            <div class="summary-general-money-item-title">Депрем-е</div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.depremal.amount) }}
              {{currencyLabel}}
            </div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-green': general[general.tabsLocal].money.encouragement.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.encouragement.amount === 0,
            }"
          >
            <div class="summary-general-money-item-title">Поощрения</div>
            <div
              v-if="general[general.tabsLocal].money.encouragement.count > 0"
              class="summary-general-money-item-count"
            >
              {{ general[general.tabsLocal].money.encouragement.count }}
            </div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.encouragement.amount) }}
              {{currencyLabel}}
            </div>
          </div>
          <div
            class="summary-general-money-item"
            :class="{
              'summary-general-money-item-red': general[general.tabsLocal].money.fines.amount > 0,
              'summary-general-money-item-gray': general[general.tabsLocal].money.fines.amount === 0,
            }"
          >
            <div class="summary-general-money-item-title">Штрафы</div>
            <div v-if="general[general.tabsLocal].money.fines.count > 0" class="summary-general-money-item-count">
              {{ general[general.tabsLocal].money.fines.count }}
            </div>
            <div class="summary-general-money-item-amount">
              {{ formatAmount(general[general.tabsLocal].money.fines.amount) }}
              {{currencyLabel}}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="userHavePermissionExpiredAndNeedAddDocuments()"
        class="summary-documents"
        @click="$router.push({ name: 'personal-employee-documents' })"
      >
        <div v-if="documents.isLoaded" class="summary-documents-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-item">
          <div
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,
              placement: 'top',
            }"
            class="summary-documents-item-icon summary-documents-item-icon-yellow"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15"
                stroke="#9FA400"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="summary-documents-item-text">{{ documents.needToAdd }}</div>
        </div>
        <div v-if="!documents.isLoaded && documents.needToAdd.length > 0" class="summary-documents-hr"></div>
        <div v-if="!documents.isLoaded && documents.expired.length > 0" class="summary-documents-item">
          <div
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,
              placement: 'top',
            }"
            class="summary-documents-item-icon summary-documents-item-icon-red"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z"
                fill="#FF238D"
              />
            </svg>
          </div>
          <div class="summary-documents-item-text">{{ documents.expired }}</div>
        </div>
        <div
          v-if="!documents.isLoaded && documents.expired.length > 0 && documents.needToAdd.length === 0"
          class="summary-documents-hr"
        ></div>
        <div
          v-if="!documents.isLoaded && documents.expired.length === 0 && documents.needToAdd.length === 0"
          class="summary-documents-empty"
        >
          Нет проблем с документами
        </div>
      </div>
      <div
        v-if="userHavePermissionUniform()"
        class="summary-uniform"
        @click="$router.push({ name: 'personal-employee-inventory-items' })"
      >
        <div v-if="inventory.isLoaded" class="summary-uniform-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-item">
          <div
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,
              placement: 'top',
            }"
            class="summary-uniform-item-icon summary-uniform-item-icon-yellow"
          >
            <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12"
                stroke="#9FA400"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="summary-documents-item-text">{{ inventory.notIssued }}</div>
        </div>
        <div v-if="!inventory.isLoaded && inventory.notIssued.length > 0" class="summary-uniform-hr"></div>
        <div v-if="!inventory.isLoaded && inventory.expired.length > 0" class="summary-uniform-item">
          <div
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: `Просроченные позиции: <b>${inventory.expired}</b>`,
              placement: 'top',
            }"
            class="summary-uniform-item-icon summary-uniform-item-icon-red"
          >
            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z"
                fill="#FF238D"
              />
            </svg>
          </div>
          <div class="summary-documents-item-text">{{ inventory.expired }}</div>
        </div>
        <div
          v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length > 0"
          class="summary-uniform-hr"
        ></div>
        <div
          v-if="!inventory.isLoaded && inventory.notIssued.length === 0 && inventory.expired.length === 0"
          class="summary-uniform-empty"
        >
          Нет проблем с инвентарем
        </div>
      </div>
      <div
        v-if="userHavePermissionFinesAndEncourage()"
        class="summary-encourage"
        @click="$router.push({ name: 'personal-employee-discipline' })"
      >
        <div v-if="encourageIsLoaded" class="summary-encourage-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!encourageIsLoaded" class="summary-encourage-title">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z"
              stroke="#12C971"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="summary-encourage-title-text">Поощрения</div>
        </div>
        <div v-for="(item, i) in encourageLocalItems" :key="`encourage-l-${i}-${item.name}`" class="summary-encourage-item">
          <template v-if="!encourageIsLoaded">
            <div class="summary-encourage-item-text">{{ item.name }}</div>
            <div class="summary-encourage-item-date">{{ item.date }}</div>
          </template>
        </div>
        <div v-if="!encourageIsLoaded && encourageLocalItems.length === 0" class="summary-encourage-empty">
          Поощрений пока нет
        </div>
      </div>
      <div
        v-if="userHavePermissionFinesAndEncourage()"
        class="summary-fines"
        @click="$router.push({ name: 'personal-employee-discipline' })"
      >
        <div v-if="finesIsLoaded" class="summary-fines-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!finesIsLoaded" class="summary-fines-title">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z"
              stroke="#FF238D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="summary-fines-title-text">Частые нарушения</div>
        </div>
        <div v-for="fine in finesLocalItems" :key="`fine-l-${fine.name}`" class="summary-fines-item">
          <template v-if="!finesIsLoaded">
            <div class="summary-fines-item-text">{{ fine.name }}</div>
            <div class="summary-fines-item-count">
              <div class="summary-fines-item-count-text">{{ fine.count }}</div>
            </div>
          </template>
        </div>
        <div v-if="!finesIsLoaded && finesLocalItems.length === 0" class="summary-fines-empty">Нарушений пока нет</div>
      </div>
      <div v-if="notifications.userHasPermission" class="summary-notices">
        <div v-if="notifications.isLoaded" class="summary-notices-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!notifications.isLoaded" class="summary-notices-title">
          <div class="summary-notices-title-text">Уведомления</div>
          <div
            class="summary-notices-title-count"
            :class="{ 'summary-notices-title-count-grey': notifications.count === 0 }"
          >
            <div class="summary-notices-title-count-text">{{ notifications.count }}</div>
          </div>
        </div>
        <div
          v-for="(notification, mobileIndex) in notifications.items"
          :key="'notification' + mobileIndex + 'mobile'"
          class="summary-notices-item"
        >
          <template v-if="!notifications.isLoaded">
            <div class="summary-notices-item-text" v-html="notification.text">{{ notification.text }}</div>
            <div class="summary-notices-item-date">{{ notification.created }}</div>
          </template>
        </div>
        <div v-if="!notifications.isLoaded && notifications.items.length === 0" class="summary-notices-empty">
          Нет новых уведомлений
        </div>
      </div>
      <div class="summary-statuses">
        <div v-if="statuses.isLoaded" class="summary-statuses-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div
          v-if="!statuses.isLoaded"
          class="summary-statuses-item"
          :class="{
            'summary-statuses-item-disabled':
              statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'workerStatus',
          }"
        >
          <div class="summary-statuses-item-title">Статус сотрудника</div>
          <div v-if="statuses.changeStatusForm !== 'workerStatus'" class="summary-statuses-item-value">
            <div
              :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
              class="summary-statuses-item-text"
            >
              {{ statuses.workerStatus }}
            </div>
            <c-button
              v-if="userHavePermissionChangeWorkerStatuses"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-statuses-item-value-icon"
              size="iconic"
              icon="edit"
              @click="statuses.changeStatusForm = 'workerStatus'"
            />
          </div>
          <div v-else class="summary-statuses-item-value align-items-start w-100">
            <c-input
              v-model="statuses.workerStatusLocal"
              class="flex-grow-1 summary-statuses-item-value-input"
              type="select"
              :searchable="true"
              :items="statuses.workerStatusLocalItem"
            />
            <c-button
              key="workerStatus1"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
              class="summary-statuses-item-value-close-icon"
              size="iconic"
              :icon="{ icon: 'close', color: 'secondary' }"
              @click="statuses.changeStatusForm = ''"
            />
            <c-button
              key="workerStatus2"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
              class="summary-statuses-item-value-apply-icon"
              size="iconic"
              :icon="{ icon: 'check', color: 'success' }"
              @click="changeStatuses"
            />
          </div>
        </div>
        <div
          v-if="!statuses.isLoaded  && userHavePermissionCharacteristic()"
          class="summary-statuses-item"
          :class="{
            'summary-statuses-item-disabled':
              statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'characteristic',
          }"
        >
          <div class="summary-statuses-item-title">Характеристика</div>
          <div v-if="statuses.changeStatusForm !== 'characteristic'" class="summary-statuses-item-value">
            <div
              :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.characteristic === 'Не выбрано' }"
              class="summary-statuses-item-text"
            >
              {{ statuses.characteristic }}
            </div>
            <c-rank-info-icon
              v-if="statuses.rankInfo !== null"
              icon-key="rankinfo-summary-mobile"
              class="summary-statuses-item-rankinfo-icon"
              :data="{ action: statuses.rankInfo.action, value: statuses.rankInfo.value }"
            />
            <c-button
              v-if="userHavePermissionChangeWorkerStatuses()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-statuses-item-value-icon"
              size="iconic"
              icon="edit"
              @click="statuses.changeStatusForm = 'characteristic'"
            />
          </div>
          <div v-else class="summary-statuses-item-value align-items-start w-100">
            <c-input
              v-model="statuses.characteristicLocalValue"
              class="flex-grow-1 summary-statuses-item-value-input"
              type="select"
              :searchable="true"
              :items="statuses.characteristicLocalItems"
            />
            <c-button
              key="workerStatus1"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
              class="summary-statuses-item-value-close-icon"
              size="iconic"
              :icon="{ icon: 'close', color: 'secondary' }"
              @click="statuses.changeStatusForm = ''"
            />
            <c-button
              key="workerStatus2"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
              class="summary-statuses-item-value-apply-icon"
              size="iconic"
              :icon="{ icon: 'check', color: 'success' }"
              @click="changeStatuses"
            />
          </div>
        </div>
        <div
          v-if="!statuses.isLoaded"
          class="summary-statuses-item"
          :class="{
            'summary-statuses-item-disabled':
              statuses.changeStatusForm.length > 0 && statuses.changeStatusForm !== 'employmentStatus',
          }"
        >
          <div class="summary-statuses-item-title">Статус трудоустройства</div>
          <div v-if="statuses.changeStatusForm !== 'employmentStatus'" class="summary-statuses-item-value">
            <div
              :class="{ 'summary-statuses-item-value-text-not-chosen': statuses.employmentStatus === 'Не выбрано' }"
              class="summary-statuses-item-text"
            >
              {{ statuses.employmentStatus }}
            </div>
            <c-button
              v-if="userHavePermissionChangeWorkerStatuses()"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              class="summary-statuses-item-value-icon"
              size="iconic"
              icon="edit"
              @click="statuses.changeStatusForm = 'employmentStatus'"
            />
          </div>
          <div v-else class="summary-statuses-item-value align-items-start w-100">
            <c-input
              v-model="statuses.employmentStatusLocalValue"
              class="flex-grow-1 summary-statuses-item-value-input"
              type="select"
              :searchable="true"
              :items="statuses.employmentStatusLocalItems"
            />
            <c-button
              key="workerStatus1"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }"
              class="summary-statuses-item-value-close-icon"
              size="iconic"
              :icon="{ icon: 'close', color: 'secondary' }"
              @click="statuses.changeStatusForm = ''"
            />
            <c-button
              key="workerStatus2"
              v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }"
              class="summary-statuses-item-value-apply-icon"
              size="iconic"
              :icon="{ icon: 'check', color: 'success' }"
              @click="changeStatuses"
            />
          </div>
        </div>
        <div
          v-if="!statuses.isLoaded"
          class="summary-statuses-additions"
          :class="{
            'summary-statuses-additions-disabled':
              statuses.changeStatusForm === 'characteristic' ||
              statuses.changeStatusForm === 'employmentStatus' ||
              statuses.changeStatusForm === 'workerStatus',
          }"
        >
          <div v-if="statuses.combinationFilials" class="summary-statuses-additions-item">
            <c-button icon="point" size="iconic" />
            <div class="summary-statuses-additions-item-text">Может работать в нескольких филиалах</div>
          </div>
          <div v-if="statuses.remoteJob" class="summary-statuses-additions-item">
            <c-button icon="home" size="iconic" />
            <div class="summary-statuses-additions-item-text">Может работать удалённо</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";
import { mapGetters } from "vuex";
import FinanceTransactionModal from "@/pages/personal-employee/finance/components/finance-transaction-modal";
import Switcher from "@/components/controls2/Switcher";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import RankInfoIcon from "@/pages/personal-employee/additions/rank-info-icon";
import newTransactionModal from "./finance/components/type-modal";

export default {
  name: "personal-employee-summary",
  components: {
    "c-switcher": Switcher,
    "c-button": Button,
    "c-input": Input,
    "m-finance-transaction": FinanceTransactionModal,
    "c-rank-info-icon": RankInfoIcon,
    FontAwesomeIcon,
    newTransactionModal,
  },
  props: ["filialId", "filialName", "workerFullName", "filialsPermission"],
  data() {
    return {
      icon: faSpinner,
      general: {
        isLoaded: true,
        tabsLocal: "today",
        today: {
          salary: "0",
          hoursWorked: "0ч 00мин",
          daysWorked: "0 смен",

          point: "",
          interval: moment().format("DD.MM.YYYY"),
          money: {
            main: {
              amount: 0,
            },
            variable: {
              amount: 0,
            },
            depremal: {
              amount: 0,
            },
            encouragement: {
              amount: 0,
              count: 0,
            },
            fines: {
              amount: 0,
              count: 0,
            },
          },
        },
        sunday: {
          salary: "0",
          hoursWorked: "0ч 00мин",
          daysWorked: "0 смен",
          point: "",
          interval: `${moment().subtract(7, "days").format("DD.MM.YYYY")} - ${moment().format("DD.MM.YYYY")}`,
          money: {
            main: {
              amount: 0,
            },
            variable: {
              amount: 0,
            },
            depremal: {
              amount: 0,
            },
            encouragement: {
              amount: 0,
              count: 0,
            },
            fines: {
              amount: 0,
              count: 0,
            },
          },
        },
        currentMonth: {
          salary: 0,
          hoursWorked: "0ч 00мин",
          daysWorked: "0 смен",
          point: "",
          interval: this.capitalize(moment().format("MMMM")),
          money: {
            main: {
              amount: 0,
            },
            variable: {
              amount: 0,
            },
            depremal: {
              amount: 0,
            },
            encouragement: {
              amount: 0,
              count: 0,
            },
            fines: {
              amount: 0,
              count: 0,
            },
          },
        },
        previousMonth: {
          salary: 0,
          hoursWorked: "0ч 00мин",
          daysWorked: "0 смен",
          point: "",
          interval: this.capitalize(moment().subtract(1, "months").format("MMMM")),
          money: {
            main: {
              amount: 0,
            },
            variable: {
              amount: 0,
            },
            depremal: {
              amount: 0,
            },
            encouragement: {
              amount: 0,
              count: 0,
            },
            fines: {
              amount: 0,
              count: 0,
            },
          },
        },
      },
      currencyLabel: '฿',
      isShowDepositTransactionModal: false,
      isShowPersonalAccountTransactionModal: false,
      money: {
        isLoaded: true,
        depositLocalValue: 0,
        personalAccountValue: 0,
        premiumAccountValue: 0,
      },
      encourageIsLoaded: true,
      encourageLocalItems: [],
      finesIsLoaded: true,
      finesLocalItems: [],
      notifications: {
        userHasPermission: true,
        isLoaded: true,
        items: [],
        count: 0,
      },
      documents: {
        isLoaded: true,
        needToAdd: "",
        expired: "",
      },
      inventory: {
        isLoaded: true,
        notIssued: "",
        expired: "",
      },
      statuses: {
        isLoaded: true,
        changeStatusForm: "",
        workerStatus: "",
        workerStatusLocal: null,
        workerStatusLocalItem: [],
        characteristic: "",
        characteristicLocalValue: null,
        characteristicLocalItems: [
          { label: "Хороший сотрудник", value: 1 },
          { label: "Стажировка", value: 2 },
          { label: "Кандидат на повышение", value: 3 },
        ],
        rankInfo: null,
        employmentStatus: "",
        employmentStatusLocalValue: null,
        employmentStatusLocalItems: [
          { label: "Оформлен", value: 1 },
          { label: "Ожидает оформления", value: 2 },
        ],
        combinationFilials: false,
        remoteJob: false,
      },
    };
  },
  computed: {
    ...mapGetters(["app/getNotificationsInfo"]),
    ...mapGetters(["getUserPermissions"]),
  },

  watch: {
    "general.tabsLocal": function (intervalName) {
      this.getMainFactorsEmployee(intervalName);
    },
    "filialId": function () {
      this.getMainFactorsEmployee("today");
    },
    "filialName": function (value) {
      this.general.today.point = value;
      this.general.currentMonth.point = value;
      this.general.sunday.point = value;
      this.general.previousMonth.point = value;
    },
    "statuses.changeStatusForm": function (value) {
      if (value === "characteristic") {
        this.$store.dispatch("employees/getReferenceValues", "characteristic").then((res) => {
          this.statuses.characteristicLocalItems = res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          const c = this.statuses.characteristicLocalItems.findIndex(
            (item) => item.label === this.statuses.characteristic,
          );
          if (c !== -1) this.statuses.characteristicLocalValue = this.statuses.characteristicLocalItems[c];
        });
      }
      if (value === "workerStatus") {
        this.statuses.workerStatusLocal = this.statuses.workerStatusLocalItem.find(
          (item) => item.label === this.statuses.workerStatus,
        );
      }
      if (value === "employmentStatus") {
        this.$store.dispatch("personalEmployee/getEmploymentStatuses").then((res) => {
          this.statuses.employmentStatusLocalItems = res.response.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          const c = this.statuses.employmentStatusLocalItems.findIndex(
            (item) => item.label === this.statuses.employmentStatus,
          );
          if (c !== -1) this.statuses.employmentStatusLocalValue = this.statuses.employmentStatusLocalItems[c];
        });
      }
    },
  },

  async created() {
    this.getMoneyWorkerData();
    this.getFinesAndEncourageWorkerData();
    this.getWorkerNotificationsData();
    this.getExpiredDocumentsWorkerData();
    this.getNeedAddDocumentsWorkerData();
    this.getInventoryWorkerData();
    this.getStatusesWorkerData();
    this.getWorkerStatuses();
    this.getCurrencyLabel()
    if (this.filialId) {
      this.getMainFactorsEmployee("today");
    }
  },

  methods: {
    userHavePermissionMainFactors() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes("viewMainFactors") || userPermissions.includes("viewOwnMainFactors");
    },

    userHavePermissionCharacteristic() {
      const userPermissions = this.getUserPermissions;
      //console.log(userPermissions);
      return !userPermissions.includes("hideWorkerStatus");

    },

    userHavePermissionFinesAndEncourage() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes("viewFineBonus") || userPermissions.includes("viewOwnFineBonus");
    },

    userHavePermissionExpiredAndNeedAddDocuments() {
      const userPermissions = this.getUserPermissions;
      return (
        userPermissions.includes("updateWorkerDocuments") ||
        userPermissions.includes("viewOwnDocuments") ||
        userPermissions.includes("viewWorkerDocuments")
      );
    },

    userHavePermissionUniform() {
      const userPermissions = this.getUserPermissions;
      return (
        userPermissions.includes("updateWorkerUniform") ||
        userPermissions.includes("viewOwnUniform") ||
        userPermissions.includes("viewWorkerUniform")
      );
    },

    userHavePermissionChangeWorkerStatuses() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes("workerControl") || userPermissions.includes("workerControlFilial");
    },

    userHavePermissionUpdatePersonalAmount() {
      const userPermissions = this.getUserPermissions;
      if (userPermissions.includes("updatePersonalAmount")) {
        if (this.filialsPermission && ("updatePersonalAmount" in this.filialsPermission)) {
          return  this.filialsPermission["updatePersonalAmount"]==0 || this.filialsPermission["updatePersonalAmount"].findIndex((f) => f==this.filialId)>=0;
        }
        return  true;
      }
      return false;

    },

    userHavePermissionUpdateWorkerDeposit() {
      const userPermissions = this.getUserPermissions;
      if (userPermissions.includes("updateWorkerDeposit")) {
        if (this.filialsPermission && ("updateWorkerDeposit" in this.filialsPermission)) {
          return  this.filialsPermission["updateWorkerDeposit"]==0 || this.filialsPermission["updateWorkerDeposit"].findIndex((f) => f==this.filialId)>=0;
        }
        return  true;
      }

      return userPermissions.includes("updateWorkerDeposit");
    },

    showDepositModal() {
      if (this.userHavePermissionUpdateWorkerDeposit()) this.isShowDepositTransactionModal = true; 
      this.$refs.depositModal.open(); 
    },

    getMainFactorsEmployee(intervalName) {
      if (this.userHavePermissionMainFactors()) {
        this.general.isLoaded = true;
        const today = moment().format("DD.MM.YYYY");
        const workerId = this.$route.params.id;
        let periodStart = "";
        let periodEnd = "";

        switch (intervalName) {
          case "today":
            periodStart = today;
            periodEnd = today;
            break;
          case "sunday":
            periodStart = moment().subtract(7, "days").format("DD.MM.YYYY");
            periodEnd = today;
            break;
          case "currentMonth":
            periodStart = moment().startOf("month").format("DD.MM.YYYY");
            periodEnd = today;
            break;
          case "previousMonth":
            periodStart = moment().subtract(1, "month").startOf("month").format("DD.MM.YYYY");
            periodEnd = moment().subtract(1, "month").endOf("month").format("DD.MM.YYYY");
            break;
          default:
            console.log("Произошла ошибка");
        }

        this.$store.dispatch('personalEmployee/getDataWorkerMainFactors', {
          userId: workerId,
          periodStart,
          periodEnd,
          dataType: 'summary',
          filial: this.filialId,
        }).then((result) => {
          let data = result.response

          this.general.today.point = this.filialName
          this.general.currentMonth.point = this.filialName
          this.general.sunday.point = this.filialName
          this.general.previousMonth.point = this.filialName

          if (data[0]) {
            let mainFactorsWorker = data[0]
            this.general[intervalName].salary = Math.round(mainFactorsWorker.total)
            let hours = Math.floor(mainFactorsWorker.worked_hour)
            let minutes = Math.round((mainFactorsWorker.worked_hour-hours)*60)
            if (minutes<10) minutes = '0'+minutes;
            //let minutes = 0 
            this.general[intervalName].daysWorked = mainFactorsWorker.worked_day +' см.'
            this.general[intervalName].hoursWorked = hours + 'ч ' + minutes + 'мин'
            this.general[intervalName].point = mainFactorsWorker.filial_name
            this.general[intervalName].money.main.amount = Math.round(mainFactorsWorker.paid)
            this.general[intervalName].money.variable.amount = Math.round(mainFactorsWorker.bonus)
            this.general[intervalName].money.depremal.amount = Math.round(mainFactorsWorker.penalty)
            this.general[intervalName].money.encouragement.amount = Math.round(mainFactorsWorker.summ_bonus)
            this.general[intervalName].money.encouragement.count = mainFactorsWorker.count_bonus
            this.general[intervalName].money.fines.amount = Math.round(mainFactorsWorker.summ_fine) 
            this.general[intervalName].money.fines.count = Math.round(mainFactorsWorker.count_fine)
          } 

            setTimeout(() => {
              this.general.isLoaded = false;
            }, 200);
          });
      }
    },

    getMoneyWorkerData() {
      this.money.isLoaded = true;
      const workerId = this.$route.params.id;

      this.$store
        .dispatch("personalEmployee/getSummaryWorkerAccountInfo", {
          workerId,
        })
        .then((result) => {
          const data = result.response;
          console.log(data)
          if (data.deposit_info !== undefined) {
            this.money.depositLocalValue = data.deposit_info.summ;
          } else {
            this.money.depositLocalValue = false;
          }
          if (data.personal_amount !== undefined && data.personal_amount !== null) {
            this.money.personalAccountValue = data.personal_amount;
            console.log(data)
          } else {
            this.money.personalAccountValue = false;
          }
          if (data.premium_amount !== undefined && data.premium_amount !== null) {
            this.money.premiumAccountValue = data.premium_amount;
          } else {
            this.money.premiumAccountValue = false;
          }

          setTimeout(() => {
            this.money.isLoaded = false;
          }, 200);
        });
    },

    getFinesAndEncourageWorkerData() {
      this.finesIsLoaded = true;
      this.encourageIsLoaded = true;
      const workerId = this.$route.params.id;
      this.$store
        .dispatch("personalEmployee/getInfoDisciplineForWorker", {
          workerId,
          periodStart: "",
          periodEnd: "",
          sortBy: "date_timestamp",
          sortType: "desc",
          page: 1,
        })
        .then((result) => {
          const data = result.response;
          if (data.summary.bonuses.summary) {
            this.encourageLocalItems = data.list
              .filter((item) => item.is === "Премия")
              .map((item) => ({
                name: item.reason,
                date: item.date,
              }));
            if (this.encourageLocalItems.length > 3) {
              this.encourageLocalItems = this.encourageLocalItems.slice(0, 3);
            }
          } else {
            this.encourageLocalItems = [];
          }

          if (data.summary.fines.summary) {
            if (data.summary.fines.summary.length > 3) {
              this.finesLocalItems = data.summary.fines.summary.slice(0, 3);
            } else {
              this.finesLocalItems = data.summary.fines.summary;
            }
          } else {
            this.finesLocalItems = [];
          }

          setTimeout(() => {
            this.finesIsLoaded = false;
            this.encourageIsLoaded = false;
          }, 200);
        });
    },

    getWorkerStatuses() {
      this.$store.dispatch("employees/getReferenceValues", "workerStatus").then((res) => {
        this.statuses.workerStatusLocalItem = res.data.map((status) => ({
          value: status.id,
          label: status.name,
          fired: status.fired,
        }));
      });
    },

    getCurrencyLabel() {
      this.notifications.isLoaded = true;
      this.$store.dispatch("personalEmployee/getCurrencyLabel").then((result) => {
        console.log(result);

        this.currencyLabel = result;
        this.notifications.isLoaded = false;
      });
    },

    getWorkerNotificationsData() {
      this.notifications.isLoaded = true;
      const workerId = this.$route.params.id;
      this.$store.dispatch("personalEmployee/getSummaryWorkerNotifications", workerId).then((result) => {
        const data = result.response;

        if (data.success !== undefined && !data.success) {
          this.notifications.userHasPermission = false;
        }

        this.notifications.items = data.notifications.length > 3 ? data.notifications.slice(0, 3) : data.notifications;
        this.notifications.count = data.notifications_count;
        this.notifications.isLoaded = false;
      });
    },

    getExpiredDocumentsWorkerData() {
      this.documents.isLoaded = true;
      const workerId = this.$route.params.id;
      this.$store
        .dispatch("personalEmployee/getWorkerDocuments", {
          workerId,
          isArchive: 0,
          sortBy: "created",
          sortType: "desc",
        })
        .then((result) => {
          this.documents.expired = "";
          const data = result.response;
          const expiredDocuments = [];
          Object.values(data).forEach((documents) => {
            documents.forEach((document) => {
              if (document.expired) {
                expiredDocuments.push(document.doc_name);
              }
            });
          });
          this.documents.expired = expiredDocuments.join(", ");
          this.documents.isLoaded = false;
        });
    },

    getNeedAddDocumentsWorkerData() {
      this.documents.isLoaded = true;
      let isArchive = 0;
      const workerId = this.$route.params.id;
      this.$store.dispatch("personalEmployee/getListRequiredDocuments", {workerId, isArchive}).then((result) => {
        this.documents.needToAdd = "";
        const data = result.response;
        const needToAddDocuments = [];
        Object.values(data).forEach((documents) => {
          documents.forEach((document) => {
            needToAddDocuments.push(document.name);
          });
        });
        this.documents.needToAdd = needToAddDocuments.join(", ");
        this.documents.isLoaded = false;
      });
    },

    getInventoryWorkerData() {
      this.inventory.isLoaded = true;
      const workerId = this.$route.params.id;
      this.$store.dispatch("personalEmployee/getWorkerInventoryItemsList", workerId).then((result) => {
        this.inventory.expired = "";
        this.inventory.notIssued = "";
        const expiredInventories = [];
        const notIssuedInventories = [];

        const getStatus = (data) => {
          const result = [];
          const getNameByStatus = (data) => {
            if (data && typeof data === "object" && !Array.isArray(data)) {
              Object.keys(data).forEach((key) => {
                if (key === "status") {
                  result.push({
                    name: data.name,
                    status: data.status,
                  });
                } else {
                  getNameByStatus(data[key]);
                }
              });
            } else if (Array.isArray(data)) {
              data.forEach((item) => {
                getNameByStatus(item);
              });
            }
          };

          getNameByStatus(data);
          return result;
        };

        const itemsWithStatus = getStatus(result.response);

        itemsWithStatus.forEach((inventory) => {
          if (inventory.status === "Выдан, просрочен") {
            expiredInventories.push(inventory.name);
          }
          if (inventory.status === "Не выдан") {
            notIssuedInventories.push(inventory.name);
          }
        });
        this.inventory.expired = expiredInventories.join(", ");
        this.inventory.notIssued = notIssuedInventories.join(", ");
        this.inventory.isLoaded = false;
      });
    },

    getStatusesWorkerData() {
      this.statuses.isLoaded = true;
      const workerId = this.$route.params.id;
      this.$store.dispatch("personalEmployee/getSummaryWorkerStatuses", workerId).then((result) => {
        const data = result.response;
        this.statuses.workerStatus = data.status !== null ? data.status : "Не выбрано";
        this.statuses.characteristic = data.characteristic !== null ? data.characteristic : "Не выбрано";
        this.statuses.employmentStatus = data.employment_status !== null ? data.employment_status : "Не выбрано";
        this.statuses.remoteJob = data.remote_job;
        this.statuses.combinationFilials = data.combination_filials;

        if (data.rank_info !== false) {
          this.statuses.rankInfo = data.rank_info;
        }
        this.statuses.isLoaded = false;
      });
    },

    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    formatAmount(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    formatAmountWithNegative(x) {
      if (x > 0) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (x < 0) {
        return `- ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    addDataToDeposit(type, data) {
      this.$store
        .dispatch("personalEmployee/executeTransactionDeposit", {
          operationType: type === "make" ? "add" : "cut",
          workerId: this.$route.params.id,
          workerIdWhoContributed: data.whoContributedLocal.value,
          amount: data.summLocal,
          date: data.dateEntryLocal,
          comment: data.commentLocal,
          usePersonalAccount: data.switcherLocal ? "1" : "0",
          authorIsUser: data.whoContributedLocal.isUser ? 1 : 0,
          filial_id: data.selectedFilial ? data.selectedFilial.value : null,
          post_code: data.selectedPost ? data.selectedPost.value : null,
          company_id: data.selectedCompany ? data.selectedCompany.value : null
        })
        .then((res) => {
          if (res.response.status === "success") {
            if (type === "make") {
              this.money.depositLocalValue += Number(data.summLocal);
            } else {
              this.money.depositLocalValue -= Number(data.summLocal);
            }

            this.$notify({
              group: "success-message",
              data: {
                textMessage: type === "make" ? "Средства на депозит внесены" : "Средства с депозита сняты",
              },
            });
          }
        })
        .catch((e) => {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте ещё раз."
            },
          });
        });
    },
    addDataToPersonalAccount(type, data) {
      this.$store
        .dispatch("personalEmployee/executeTransactionPersonalAccount", {
          operationType: type === "make" ? "add" : "cut",
          reasonId: data.reasonLocal.value,
          newReasonText: data.newReasonTextLocal,
          workerId: this.$route.params.id,
          workerIdWhoContributed: data.whoContributedLocal.value,
          amount: data.summLocal,
          date: data.dateEntryLocal,
          comment: data.commentLocal,
          authorIsUser: data.whoContributedLocal.isUser ? 1 : 0,
        })
        .then((res) => {
          if (res.response.status === "success") {
            if (type === "make") {
              this.money.personalAccountValue += Number(data.summLocal);
            } else {
              this.money.personalAccountValue -= Number(data.summLocal);
            }
          }
        });
    },
    changeStatuses() {
      const workerId = this.$route.params.id;
      switch (this.statuses.changeStatusForm) {
        case "characteristic":
          this.$store
            .dispatch("personalEmployee/editWorkerCharacteristic", {
              workerId,
              characteristicId: this.statuses.characteristicLocalValue.value,
            })
            .then((result) => {
              if (result.success) {
                this.statuses.characteristic = this.statuses.characteristicLocalValue.label;
              }
            });

          break;
        case "employmentStatus":
          this.$store
            .dispatch("personalEmployee/editWorkerEmploymentStatus", {
              workerId,
              employmentStatusId: this.statuses.employmentStatusLocalValue.value,
            })
            .then((result) => {
              if (result.success) {
                this.statuses.employmentStatus = this.statuses.employmentStatusLocalValue.label;
              }
            });
          break;
        case "workerStatus":
          this.$store
            .dispatch("employees/changeEmployeeStatus", {
              workerId,
              statusId: this.statuses.workerStatusLocal.value,
            })
            .then((res) => {
              if (res.message.status === "success") {
                this.statuses.workerStatus = this.statuses.workerStatusLocal.label;
              }
            });
          break;
        default:
          console.log("default");
      }
      this.statuses.changeStatusForm = "";
    },
    modalIsSubmitted() {
      this.getMoneyWorkerData();
      console.log('submitted')
    }
  },
};
</script>
<style scoped lang="scss">
.summary {
  &-overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 301;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    &-active {
      visibility: visible;
      opacity: 1;
    }
  }

  &-container-desktop {
    margin-top: 41px;
    display: flex;
    max-width: 1440px;
    width: 100%;

    @media screen and (max-width: 1400px) {
      display: none;
    }
  }

  &-container-tablet {
    margin-top: 41px;
    display: none;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    padding-bottom: 50px;

    @media screen and (max-width: 1400px) {
      display: flex;
    }

    @media screen and (max-width: 700px) {
      display: none;
    }
  }

  &-container-mobile {
    margin-top: 29px;
    display: none;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    padding-bottom: 21px;

    @media screen and (max-width: 700px) {
      display: flex;
    }
  }

  &-ml {
    margin-left: 10px;
  }

  &-general {
    width: 100%;
    height: 280px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    border: 1px solid #dfe4ef;
    padding: 20px 25px 0 25px;
    box-sizing: border-box;
    margin-bottom: 10px;

    @media screen and (max-width: 1400px) {
      max-width: 100%;
    }

    @media screen and (max-width: 700px) {
      margin-bottom: 0;
      height: auto;
      margin-left: -20px;
      padding: 20px 20px 0 20px;
      width: calc(100% + 40px);
      max-width: calc(100% + 40px);
      border-left: none;
      border-bottom: none;
      border-right: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;

      @media screen and (max-width: 700px) {
        padding-bottom: 20px;
      }
    }

    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
    }

    &-tabs {
      margin-top: 19px;

      @media screen and (max-width: 700px) {
        ::v-deep .c-switcher-group {
          width: 100%;
        }
        ::v-deep .c-switcher-group-item {
          width: 25%;
          height: auto;
          padding: 8px;
        }
        ::v-deep .c-switcher-group-item-label {
          text-align: center;
          white-space: normal;
          line-height: 100%;
          overflow: initial;
        }
      }

      @media screen and (max-width: 476px) {
        ::v-deep .c-switcher-group {
          border-radius: 50px;
        }
        ::v-deep .c-switcher-group-item:first-child {
          border-radius: 50px 0 0 50px;
        }
        ::v-deep .c-switcher-group-item:last-child {
          border-radius: 0 50px 50px 0;
        }
      }
    }

    &-main {
      display: flex;
      margin-top: 24px;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-salary {
        display: flex;
        flex-direction: column;

        &-amount {
          font-weight: bold;
          font-size: 45px;
          line-height: 40px;

          & svg {
            font-size: 34px;
            vertical-align: -2px;
          }
        }

        &-month {
          font-size: 13px;
          line-height: 20px;
        }
      }

      &-additionally {
        display: flex;
        flex-direction: column;
        margin-left: 50px;

        @media screen and (max-width: 700px) {
          margin-left: 0;
          margin-top: 16px;
        }

        &-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          &-icon {
          }

          &-text {
            margin-left: 6px;
            font-size: 13px;
            line-height: 16px;
          }
        }
      }
    }

    &-money {
      display: flex;
      width: calc(100% + 50px);
      margin-left: -25px;
      margin-top: auto;

      @media screen and (max-width: 700px) {
        flex-direction: column;
        width: calc(100% + 40px);
        margin-left: -20px;
      }

      &-item {
        position: relative;
        width: 20%;
        height: 75px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        @media screen and (max-width: 700px) {
          padding: 8px 20px;
          width: 100%;
          height: 40px;
          flex-direction: row;
          justify-content: flex-start;
        }

        &-count {
          position: absolute;
          top: 5px;
          right: 8px;
          font-weight: bold;
          font-size: 12px;
          line-height: 120%;

          @media screen and (max-width: 700px) {
            position: static;
            margin-left: 6px;
          }
        }

        &-amount {
          font-weight: 500;
          font-size: 18px;
          line-height: 22px;

          @media screen and (max-width: 700px) {
            margin-left: auto;
          }

          & svg {
            font-size: 15px;
            vertical-align: -1px;
          }
        }

        &-title {
          max-width: 72px;
          font-size: 12px;
          text-align: center;
          line-height: 110%;

          @media screen and (max-width: 700px) {
            max-width: 100%;
          }
        }

        &-green {
          background: #d0f4e3;

          & .summary-general-money-item-count {
            color: #12c971;
          }
        }

        &-gray {
          background: #f5f7fa;

          & .summary-general-money-item-amount {
            color: #8e9cbb;
          }

          & .summary-general-money-item-title {
            color: #8e9cbb;
          }
        }

        &-red {
          background: #ffe6f2;

          & .summary-general-money-item-count {
            color: #ff238d;
          }
        }
      }
    }
  }

  &-encourage {
    cursor: pointer;
    max-width: 50%;
    width: 100%;
    height: 265px;
    display: flex;
    flex-direction: column;
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    padding: 25px;

    @media screen and (max-width: 1400px) {
      height: 290px;
      max-width: calc(33.3333333333% - 5px);
    }

    @media screen and (max-width: 700px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      height: auto;
      margin-left: -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-title {
      display: flex;
      align-items: center;

      &-icon {
      }

      &-text {
        margin-left: 13px;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #12c971;
      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      padding-bottom: 15px;
      border-bottom: solid 1px #dfe4ef;
      margin-top: 13px;

      &:first-child {
        margin-top: 19px;
      }

      &:last-child {
        border-bottom: none;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }

      &-text {
        font-size: 13px;
        line-height: 16px;
      }

      &-date {
        margin-top: 2px;
        font-size: 12px;
        line-height: 120%;
        color: #8e9cbb;
      }
    }

    &-empty {
      margin-top: 19px;
      font-size: 13px;
      line-height: 16px;
      color: #8e9cbb;
    }
  }

  &-fines {
    cursor: pointer;
    max-width: 50%;
    margin-left: 10px;
    width: 100%;
    height: 265px;
    display: flex;
    flex-direction: column;
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    padding: 25px;

    @media screen and (max-width: 1400px) {
      height: 290px;
      max-width: calc(33.333333333% - 5px);
    }

    @media screen and (max-width: 700px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      height: auto;
      margin-left: -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-title {
      display: flex;
      align-items: center;

      &-icon {
      }

      &-text {
        margin-left: 13px;
        font-weight: 500;
        font-size: 15px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 18px;
        color: #ff238d;
      }
    }

    &-item {
      display: flex;
      align-items: center;
      margin-top: 13px;
      padding-bottom: 14px;
      border-bottom: solid 1px #dfe4ef;

      &:first-child {
        margin-top: 18px;
      }

      &:last-child {
        border-bottom: none;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }

      &-text {
        margin-right: 10px;
        width: 100%;
        max-width: 200px;
        font-size: 13px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 120%;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }

      &-count {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 20px;
        background: #f5f7fa;
        border-radius: 30px;

        &-text {
          font-weight: bold;
          font-size: 12px;
          line-height: 120%;
          text-align: center;
          color: #8e9cbb;
        }
      }
    }

    &-empty {
      margin-top: 19px;
      font-size: 13px;
      line-height: 16px;
      color: #8e9cbb;
    }
  }

  &-money {
    width: 100%;
    height: 75px;
    display: flex;
    margin-bottom: 10px;
    max-width: 100%;
    border: 1px solid #dfe4ef;
    box-sizing: border-box;

    @media screen and (max-width: 1400px) {
      max-width: 100%;
    }

    @media screen and (max-width: 700px) {
      margin-bottom: 0;
      margin-left: -20px;
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      height: auto;
      flex-direction: column;
      border-bottom: none;
      border-right: none;
      border-left: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;

      @media screen and (max-width: 700px) {
        padding: 20px 0;
      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 33.3333333%;
      padding: 15px 24px;

      @media screen and (max-width: 700px) {
        height: 40px;
        width: 100%;
        padding: 15px 20px;
        flex-direction: row;
        align-items: center;
      }

      &-title {
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
      }

      &-amount {
        margin-top: 2px;
        display: flex;
        align-items: center;

        @media screen and (max-width: 700px) {
          margin-left: auto;
        }

        &-text {
          font-weight: 500;
          font-size: 22px;
          line-height: 26px;

          &-no-edit {
            margin-right: 29px;
          }

          & svg {
            font-size: 17px;
            vertical-align: -1px;
          }
        }

        &-edit {
          margin-left: 8px;
        }
      }

      &-yellow {
        background: #fdffb3;
      }

      &-green {
        background: #d0f4e3;
      }

      &-red {
        background: #ffe6f2;
      }

      &-clickable {
        cursor: pointer;
      }
    }
  }

  &-documents {
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 140px;
    max-width: 50%;
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 28px;

    @media screen and (max-width: 1400px) {
      margin-left: 10px;
      max-width: 100%;
      width: auto;
    }

    @media screen and (max-width: 700px) {
      padding: 8px 28px;
      height: 121px;
      width: calc(100% + 40px);
      max-width: calc(100% + 40px);
      margin-left: -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-hr {
      position: absolute;
      left: 28px;
      height: 1px;
      width: calc(100% - 56px);
      background: #dfe4ef;
      top: 50%;

      @media screen and (max-width: 700px) {
        display: none;
      }
    }

    &-item {
      display: flex;
      align-items: center;
      height: 50%;

      &:first-child {
        margin-top: 0;
      }

      &-icon {
        width: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        margin-right: 18px;
        height: 28px;
        border-radius: 50px;

        &-yellow {
          background: #fdffb3;
        }

        &-red {
          background: #ffe6f2;
        }
      }

      &-text {
        font-size: 13px;
        max-width: 160px;
        max-height: 40px;
        display: -webkit-box;
        line-height: 100%;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }
    }

    &-empty {
      margin-top: 28px;
      font-size: 13px;
      line-height: 16px;
      color: #8e9cbb;
    }
  }

  &-uniform {
    cursor: pointer;
    position: relative;
    width: 100%;
    margin-left: 10px;
    height: 140px;
    max-width: calc(50% - 5px);
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 28px;

    @media screen and (max-width: 1400px) {
      margin-top: 10px;
      max-width: 100%;
      width: auto;
    }

    @media screen and (max-width: 700px) {
      padding: 8px 28px;
      margin-top: 0;
      height: 123px;
      width: calc(100% + 40px);
      max-width: calc(100% + 40px);
      margin-left: -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-hr {
      position: absolute;
      left: 28px;
      height: 1px;
      width: calc(100% - 56px);
      background: #dfe4ef;
      top: 50%;

      @media screen and (max-width: 700px) {
        display: none;
      }
    }

    &-item {
      display: flex;
      align-items: center;
      height: 50%;

      &:first-child {
        margin-top: 0;
      }

      &-icon {
        width: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        margin-right: 18px;
        height: 28px;
        border-radius: 50px;

        &-yellow {
          background: #fdffb3;
        }

        &-red {
          background: #ffe6f2;
        }
      }

      &-text {
        font-size: 13px;
        max-width: 160px;
        max-height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-height: 100%;
        -webkit-box-orient: vertical;
        overflow: hidden;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }
    }

    &-empty {
      margin-top: 28px;
      font-size: 13px;
      line-height: 16px;
      color: #8e9cbb;
    }
  }

  &-notices {
    width: 100%;
    height: 320px;
    margin-top: 10px;
    max-width: 50%;
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 21px 26px;

    @media screen and (max-width: 1400px) {
      max-width: calc(50% - 5px);
    }

    @media screen and (max-width: 700px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      height: auto;
      margin-top: 0;
      margin-left: -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-title {
      display: flex;
      align-items: center;

      &-text {
        max-width: 230px;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
      }

      &-count {
        margin-left: 9px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 20px;
        background: #ffe6f2;
        border-radius: 30px;

        &-grey {
          background: #f5f7fa;

          ::v-deep & .summary-notices-title-count-text {
            color: #8e9cbb;
          }
        }

        &-text {
          font-weight: bold;
          font-size: 12px;
          line-height: 120%;
          text-align: center;
          color: #ff238d;
        }
      }
    }

    &-item {
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      padding-bottom: 13px;
      border-bottom: solid 1px #dfe4ef;

      &:last-child {
        border-bottom: none;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }

      &-text {
        font-size: 13px;
        line-height: 16px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &-date {
        margin-top: 3px;
        font-size: 12px;
        line-height: 120%;
        color: #8e9cbb;
      }
    }

    &-empty {
      margin-top: 16px;
      font-size: 13px;
      line-height: 16px;
      color: #8e9cbb;
    }
  }

  &-statuses {
    height: 320px;
    width: 100%;
    margin: 10px 0 0 10px;
    max-width: calc(50% - 5px);
    border: 1px solid #dfe4ef;
    box-sizing: border-box;
    padding: 24px 25px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1400px) {
      max-width: calc(50% - 5px);
    }

    @media screen and (max-width: 700px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      height: auto;
      margin-top: 0;
      margin-left: -20px;
      border-left: none;
      border-right: none;
    }

    &-loader {
      display: flex;
      font-size: 32px;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #ff238d;
    }

    &-item {
      display: flex;
      flex-direction: column;

      &-disabled {
        opacity: 0.3;
      }

      &:nth-child(1) {
        margin-bottom: 14px;
      }

      &:nth-child(2) {
        margin-bottom: 20px;
      }

      &:nth-child(3) {
        margin-bottom: 29px;
      }

      &-title {
        font-size: 13px;
        line-height: 16px;
        color: #8e9cbb;
      }

      &-rankinfo-icon {
        margin-left: 9px;
      }

      &-value {
        position: relative;
        z-index: 302;
        display: flex;
        align-items: center;
        margin-top: 7px;

        &-text {
          font-weight: 500;
          font-size: 18px;
          line-height: 22px;

          &-not-chosen {
            color: #8e9cbb;
          }
        }

        &-icon {
          margin-left: 6px;
        }

        &-close-icon {
          cursor: pointer;
          margin-left: 12px;
        }

        &-apply-icon {
          cursor: pointer;
          margin-left: 7px;
        }

        &-input {
          // max-width: 166px;
          //max-width: calc(100% - 110px);

          @media screen and (max-width: 1400px) {
            max-width: 100%;
          }

          @media screen and (min-width: 700px) {
            ::v-deep & .c-input-container-list-item-label {
              overflow: hidden;
              white-space: normal;
              text-overflow: ellipsis;
              line-height: 1;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }

    &-additions {
      display: flex;
      flex-direction: column;

      &-disabled {
        opacity: 0.3;
      }

      &-item {
        display: flex;
        align-items: center;

        &:first-child {
          margin-bottom: 18px;
        }

        &-text {
          font-weight: normal;
          font-size: 13px;
          line-height: 110%;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
